import {useState,useContext,useEffect} from 'react';
import hero from './../data/Unit.json';
import {AppContext} from '../context/AppContext';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Select from 'react-select';
import './../styles/Select.scss';
import {toPng} from 'html-to-image';
import download from 'downloadjs';
import { useSearchParams } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import _ from "lodash";

function Esper(props) {
    let esper = props.esper;
    let index = props.index;
    let mainList = props.mainList;

    let grayedOut = props.grayedOut
    const {searchKey} = useContext(AppContext);
    
    return (
        <Draggable key={esper.ID} draggableId={esper.ID.toString()} index={index}>
            {(provided, snapshot) => (
                <div className={`${esper.show === false && mainList ? 'hidden' : ''} ${searchKey("UnitTag;TagName;"+esper.UnitTag).toUpperCase()} relative max-w-[80px] items-center`} style={{userSelect: 'none'}} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                    <div className='absolute z-10 rounded-tr-lg right-0 rounded-bl-lg w-[25%]'>
                        <img alt="type" src={`img/type/UnitJob${esper.TypeID}.png`} style={{width: '100%'}} className={`${!esper.checked && grayedOut ? 'grayscale':''} rounded-tr-lg rounded-bl-lg`}/>
                    </div>
                    <div className='absolute z-10 top-0 left-0'><img className='w-[27%] rounded-full bg-[#171e26] border' src={`img/tags/${esper.UnitTag}.png`} alt={searchKey("UnitTag;TagName;"+esper.UnitTag)}/></div>
                    <div>
                        <img className={`rounded-full border ${!esper.checked && grayedOut ? 'grayscale':''}`} src={`img/charArt/Tex_UI_${esper.EnglishName}_CharArt${esper.ID}_256.png`} alt="avatar"/>
                    </div>
                    <div>
                        <div className="text-xs w-full flex flex-col gap-1 items-center justify-center">
                            <div>{searchKey("Unit;NickName;"+esper.ID)}</div>
                        </div>    
                    </div>
                </div>
            )}
        </Draggable>
        
      )
}
function TierList() {
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams();
    const {searchKey,translate,customStyle,collection} = useContext(AppContext);
    
    const [state, setState] = useState([[[],[],[],[]],[[],[],[],[]],[[],[],[],[]],[[],[],[],[]],[[],[],[],[]],hero.filter((h) => h.Enable === true && h.HeroType === "Hero").map(x => {x.checked = collection.includes(x.ID);x.show = true;return x;})]);
    const [name,setName] = useState("");
    const [type,setType] = useState("");
    const [searchQ,setSearchQ] = useState("");
    const [grayedOut,setGrayedOut] = useState(true);
    const [selectedHero,setSelectedHero] = useState([]);
    const [currentTypeDrag,setCurrentTypeDrag] = useState(null);

    const [typeList,setTypeList] = useState([
        {"id": 1,"name":searchKey("UnitTag;TagName;1"),"show": true},
        {"id": 2,"name":searchKey("UnitTag;TagName;2"),"show": true},
        {"id": 3,"name": searchKey("UnitTag;TagName;3"),show: true},
        {"id": 4,"name": searchKey("UnitTag;TagName;4"),show: true}])
    
    const screenShot = () => {
        let initialGrayedOut = grayedOut;
        if(grayedOut === true) { setGrayedOut(false)}
		const html = document.getElementsByTagName("html")[0];
		const body = document.getElementsByTagName("body")[0];
		html.style.width = 1400 + "px";
		body.style.width = 1400 + "px";

		toPng(document.getElementById('tierList'))
		.then(function (dataUrl) {
			download(dataUrl, 'tierList.png');
			html.style.width = null;
			body.style.width = null;
            setGrayedOut(initialGrayedOut);
		});
	}
    /**
     * Moves an item from one list to another list.
     */
     const move = (source, destination, droppableSource, droppableDestination) => {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(droppableSource.index, 1);
      
        destClone.splice(droppableDestination.index, 0, removed);
      
        const result = {};
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;
        
        return result;
    };
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        
        return result;
      };
    function onDragEnd(result) {
        const { source, destination } = result;
        // dropped outside the list
        if (!destination) {
          return;
        }
        
        const sInd = source.droppableId;
        const dInd = destination.droppableId;

        let dIndex1 = null;let dIndex2 = null;let sIndex1 = null;let sIndex2 = null;let elementDestination = null;let elementSource = null;
        let dSlot = false;
        let sSlot = false;

        if(dInd.indexOf("-") !== -1){
            let temp = dInd.split("-");
            dSlot = true;
            dIndex1 = parseInt(temp[0]);
            dIndex2 = parseInt(temp[1]);
            elementDestination = state[dIndex1][dIndex2];
        } else {
            elementDestination = state[5];
        }
        if(sInd.indexOf("-") !== -1){
            let temp = sInd.split("-");
            sSlot = true
            sIndex1 = parseInt(temp[0]);
            sIndex2 = parseInt(temp[1]);
            elementSource = state[sIndex1][sIndex2];
        } else {
            elementSource = state[5];
        }

        // we need to check if is the right type
        // fighter => 1
        // controller => 4
        // defender => 2
        // support => 3
        switch(dIndex2) {
            case 0:
                if(currentTypeDrag !== 1){
                    return;
                }
                break;
            case 1:
                if(currentTypeDrag !== 4){
                    return;
                }
                break;
            case 2:
                if(currentTypeDrag !== 2){
                    return;
                }
                break;
            case 3:
                if(currentTypeDrag !== 3){
                    return;
                }
                break;
            default:
                break;
        }


        const newState = _.cloneDeep(state);
        if (sInd === dInd) {
            const items = reorder([...elementSource], source.index, destination.index);
            if(sSlot) {
                newState[sIndex1][sIndex2] = items;
            } else {
                newState[5] = items;
            }
            
            setState(newState);
        } else {
            const result = move(elementSource, elementDestination, source, destination);
            if(dSlot) {
                newState[dIndex1][dIndex2] = result[dInd];
            } else {
                newState[5] = result[dInd];
            }
            if(sSlot) {
                newState[sIndex1][sIndex2] = result[sInd];
            } else {
                newState[5] = result[sInd];
            }
            
            setState(newState);
        }
        setCurrentTypeDrag(null);
    }
    function isDropDisabled(type) {
        if(type === currentTypeDrag) {
            return false;
        } else {
            return true;
        }
    }
    function onDragStart(result) {
        let iType = null;
        let source = result.source;
        if(source.droppableId.indexOf("-") !== -1){
            // slot
            let temp = source.droppableId.split("-");
                        let index1 = parseInt(temp[0]);
            let index2 = parseInt(temp[1]);
                        iType = state[index1][index2][source.index].UnitTag
                    } else {
            // source total list
            iType = state[5][source.index].UnitTag
        }
        setCurrentTypeDrag(iType);

    }
    const getTypeOption = () => {
        let options = [];
        let erebiumRituel = {
            label: translate("Equipment"),
            options: [
              { label: <div className='flex flex-row gap-2 items-center'><div><img className='h-[48px]' alt={searchKey("BossTips;GameName;EquipmentStage-1")} src="img/boss/Tex_UI_BossWest01_BattleCharHead180010.png"/>
                    </div>
                    <div>{searchKey("BossTips;GameName;EquipmentStage-1")}</div>
                </div>, value: "1" },
              { label: <div className='flex flex-row gap-2 items-center'><div><img  className='h-[48px]' alt={searchKey("BossTips;GameName;EquipmentStage-2")} src="img/boss/Tex_UI_BossSouth_BattleCharHead80021.png"/></div><div>{searchKey("BossTips;GameName;EquipmentStage-2")}</div></div>, value: "2" },
              { label: <div className='flex flex-row gap-2 items-center'><div><img  className='h-[48px]' alt={searchKey("BossTips;GameName;EquipmentStage-3")} src="img/boss/Tex_UI_BossFafnir_BattleCharHead80024.png"/></div><div>{searchKey("BossTips;GameName;EquipmentStage-3")}</div></div>, value: "3" }
            ]
        }
        options.push(erebiumRituel);
        let erebiumSonique = {
            label: <>{translate("Awake")}</>,
            options: [
              { label: <div className='flex flex-row gap-2 items-center'><div><img  className='h-[48px]' alt={searchKey("BossTips;GameName;AwakeStage-1")} src="img/boss/Tex_UI_BossAwake_C_BattleCharHead80016.png"/></div><div>{searchKey("BossTips;GameName;AwakeStage-1")}</div></div>, value: "4" },
              { label: <div className='flex flex-row gap-2 items-center'><div><img  className='h-[48px]' alt={searchKey("BossTips;GameName;AwakeStage-2")} src="img/boss/Tex_UI_BossAwake_A_BattleCharHead80017.png"/></div><div>{searchKey("BossTips;GameName;AwakeStage-2")}</div></div>, value: "5" },
              { label: <div className='flex flex-row gap-2 items-center'><div><img  className='h-[48px]' alt={searchKey("BossTips;GameName;AwakeStage-3")} src="img/boss/Tex_UI_BossAwake_B_BattleCharHead80018.png"/></div><div>{searchKey("BossTips;GameName;AwakeStage-3")}</div></div>, value: "6" },
              { label: <div className='flex flex-row gap-2 items-center'><div><img  className='h-[48px]' alt={searchKey("BossTips;GameName;AwakeStage-4")} src="img/boss/Tex_UI_BossAwake_D_BattleCharHead80019.png"/></div><div>{searchKey("BossTips;GameName;AwakeStage-4")}</div></div>, value: "7" }
            ]
        }
        options.push(erebiumSonique);

        let pvp = {
            label: <>{translate("PvP")}</>,
            options: [
              { label: <>{translate('Point War (Attack)')}</>, value: "8" },
              { label: <>{translate('Point War (Defense)')}</>, value: "9" }
            ]
        }
        options.push(pvp);

        let pve = {
            label: <>{translate("PvE")}</>,
            options: [
              { label: <>{translate('Story')}</>, value: "10" },
              { label: <>{translate('Cube')}</>, value: "11" },
              { label: <>{searchKey("Space_Show_Info_3")}</>, value: "12" }
            ]
        }
        options.push(pve);
        
        return options;
    }
    const selectType = (e) => {
        setType(e.label);
    }
    useEffect(() => {
        if(searchParams.get("tSSS") !== null || searchParams.get("tSS")!= null || searchParams.get("tS")!= null || searchParams.get("tA")!= null || searchParams.get("tB")!= null){
            loadDataFromUrl();    
        }
    // eslint-disable-next-line
    }, [searchParams])
    const generateLink = () => {
        // 0 fighter
        // 1 controller
        // 2 defender
        // 3 support
        let tSSSf = state[0][0].map(s => s.ID);
        let tSSSc = state[0][1].map(s => s.ID);
        let tSSSd = state[0][2].map(s => s.ID);
        let tSSSs = state[0][3].map(s => s.ID);
        let tSSS = tSSSf.join(",") + "-" + tSSSc.join(",") + "-" + tSSSd.join(",") + "-" + tSSSs.join(",");

        
        let tSSf = state[1][0].map(s => s.ID);
        let tSSc = state[1][1].map(s => s.ID);
        let tSSd = state[1][2].map(s => s.ID);
        let tSSs = state[1][3].map(s => s.ID);
        let tSS = tSSf.join(",") + "-" + tSSc.join(",") + "-" + tSSd.join(",") + "-" + tSSs.join(",");

        let tSf = state[2][0].map(s => s.ID);
        let tSc = state[2][1].map(s => s.ID);
        let tSd = state[2][2].map(s => s.ID);
        let tSs = state[2][3].map(s => s.ID);
        let tS = tSf.join(",") + "-" + tSc.join(",") + "-" + tSd.join(",") + "-" + tSs.join(",");

        let tAf = state[3][0].map(s => s.ID);
        let tAc = state[3][1].map(s => s.ID);
        let tAd = state[3][2].map(s => s.ID);
        let tAs = state[3][3].map(s => s.ID);
        let tA = tAf.join(",") + "-" + tAc.join(",") + "-" + tAd.join(",") + "-" + tAs.join(",");

        let tBf = state[4][0].map(s => s.ID);
        let tBc = state[4][1].map(s => s.ID);
        let tBd = state[4][2].map(s => s.ID);
        let tBs = state[4][3].map(s => s.ID);
        let tB = tBf.join(",") + "-" + tBc.join(",") + "-" + tBd.join(",") + "-" + tBs.join(",");

        let link = window.location.href.split("?")[0]+`?tSSS=${tSSS}&tSS=${tSS}&tS=${tS}&tA=${tA}&tB=${tB}`;
        //document.getElementById('tierListLink').value = link;
        navigator.clipboard.writeText(link)
        setTimeout(function(){ReactTooltip.hide();}, 1000);
        
    }
    const loadDataFromUrl = () => {
        if(state[0][0].length === 0 && state[0][1].length === 0 && state[0][2].length === 0 && state[0][3].length === 0 && state[1][0].length === 0 && state[1][1].length === 0 && state[1][2].length === 0 && state[1][3].length === 0 && state[2][0].length === 0 && state[2][1].length === 0 && state[2][2].length === 0 && state[2][3].length === 0 && state[3][0].length === 0 && state[3][1].length === 0 && state[3][2].length === 0 && state[3][3].length === 0 && state[4][0].length === 0 && state[4][1].length === 0 && state[4][2].length === 0 && state[4][3].length === 0){
            
        let tSSS = searchParams.get("tSSS").split("-");
        let tSSSf = tSSS[0].split(",");
        let tSSSc = tSSS[1].split(",");
        let tSSSd = tSSS[2].split(",");
        let tSSSs = tSSS[3].split(",");
        let tabMergeSSS = [tSSSf, tSSSc, tSSSd, tSSSs];

        let tSS = searchParams.get("tSS").split("-");
        let tSSf = tSS[0].split(",");
        let tSSc = tSS[1].split(",");
        let tSSd = tSS[2].split(",");
        let tSSs = tSS[3].split(",");
        let tabMergeSS = [tSSf, tSSc, tSSd, tSSs];

        let tS = searchParams.get("tS").split("-");
        let tSf = tS[0].split(",");
        let tSc = tS[1].split(",");
        let tSd = tS[2].split(",");
        let tSs = tS[3].split(",");
        let tabMergeS = [tSf, tSc, tSd, tSs];

        let tA = searchParams.get("tA").split("-");
        let tAf = tA[0].split(",");
        let tAc = tA[1].split(",");
        let tAd = tA[2].split(",");
        let tAs = tA[3].split(",");
        let tabMergeA = [tAf, tAc, tAd, tAs];

        let tB = searchParams.get("tB").split("-");
        let tBf = tB[0].split(",");
        let tBc = tB[1].split(",");
        let tBd = tB[2].split(",");
        let tBs = tB[3].split(",");
        let tabMergeB = [tBf, tBc, tBd, tBs];

        let tabIdToDelete = [];
        let esperList = hero.filter((h) => h.Enable === true && h.HeroType === "Hero").map(x => {x.checked = collection.includes(x.ID);x.show = true;return x;})
        let newState = [...state];

        tabMergeSSS.forEach((tabRole,index) => {
            tabRole.forEach((id) => {
                let found = esperList.find(e => e.ID === parseInt(id));
                if(found){
                    tabIdToDelete.push(found.ID);
                    newState[0][index].push(found);
                }
            })
        })
        tabMergeSS.forEach((tabRole,index) => {
            tabRole.forEach((id) => {
                let found = esperList.find(e => e.ID === parseInt(id));
                if(found){
                    tabIdToDelete.push(found.ID);
                    newState[1][index].push(found);
                }
            })
        })
        tabMergeS.forEach((tabRole,index) => {
            tabRole.forEach((id) => {
                let found = esperList.find(e => e.ID === parseInt(id));
                if(found){
                    tabIdToDelete.push(found.ID);
                    newState[2][index].push(found);
                }
            })
        })
        tabMergeA.forEach((tabRole,index) => {
            tabRole.forEach((id) => {
                let found = esperList.find(e => e.ID === parseInt(id));
                if(found){
                    tabIdToDelete.push(found.ID);
                    newState[3][index].push(found);
                }
            })
        })
        tabMergeB.forEach((tabRole,index) => {
            tabRole.forEach((id) => {
                let found = esperList.find(e => e.ID === parseInt(id));
                if(found){
                    tabIdToDelete.push(found.ID);
                    newState[4][index].push(found);
                }
            })
        })
        esperList = esperList.map(e => {
            if(tabIdToDelete.includes(e.ID)) {
                e.show = false;
            } else {
                e.show = true;
            }
            return e;
        });

        newState[5] = esperList;
        setSelectedHero(tabIdToDelete);
        setState(newState);
        
        }
    }
    const toggleType = (e) => {
		let currentType = e.target;
		if(currentType.checked) {
			let temp = typeList.map((t) => {
				if(t.id.toString() === currentType.value){
					t.show = true;
				}
				return t;
			})
			setTypeList(temp)
		} else {
			let temp = typeList.map((t) => {
				if(t.id.toString() === currentType.value){
					t.show = false;
				}
				return t;
			})
			setTypeList(temp)
		}
  	}
    useEffect(() => {
        displayEsper();
        // eslint-disable-next-line
    },[typeList,searchQ,selectedHero]);

    const displayEsper = () => {
        const newState = [...state];
        let temp5 = _.cloneDeep(newState[5]).map(x => {
            let tempType = typeList.find((t) => t.id === x.UnitTag);
            if(searchQ !== "") {
                x.show = tempType.show && (searchKey(x.Name).toLowerCase().includes(searchQ.toLowerCase()) || searchKey(x.NickName).toLowerCase().includes(searchQ.toLowerCase()))
            } else {
                x.show = tempType.show;
            }
            if(selectedHero.includes(x.ID)){
                x.show = false;
            }
            return x;
        })
        newState[5] = temp5;
        setState(newState);
    }

    return (
        <>
        <ReactTooltip id="copyTierList" place="top" isCapture={true} effect="solid" event="click"/>
        <div className='typeTierList p-2'>
            <div className='flex flex-col md:flex-row gap-2'>
                <div className='flex flex-row gap-2 items-center'>
                    <div><label className=''>{translate('Name')}</label></div>
                    <div><input type="text" onChange={(e) => setName(e.target.value)} name="tierListName" className='bg-[#212932]' placeholder='Name of the tier list...'/></div>
                </div>
                <div className='flex flex-row gap-2 items-center justify-between md:justify-start w-full md:w-[50%]'>
                    <div className=""><label className=''>{translate('For what ?')}</label></div>
                    <div className='grow-1 w-[75%] md:w-[50%]'>
                        <Select classNamePrefix='filter' onChange={(e) => selectType(e)} isSearchable={false} styles={customStyle}  menuPortalTarget={document.body} options={getTypeOption()}/>
                    </div>
                </div>
            </div>
            <div className='flex flex-col md:flex-row gap-2 mt-2 justify-between'>
                <div className='flex md:flex-row flex-col gap-2'>
                <button className='text-left hover:bg-[#171e26] border-[#646464]  border py-2 px-4 rounded bg-[#212932]' onClick={() => screenShot()}>{translate('🖼️ Save image of tier list')}</button>
                <button data-tip={translate("Copy to clipboard !")} data-delay-hide='1000' data-for="copyTierList" data-type="success" className='text-left hover:bg-[#171e26] border-[#646464]  border py-2 px-4 rounded bg-[#212932]' onClick={() => generateLink()}>{translate('📙 Generate link')}</button>
                </div>
                <div className='flex flex-row gap-2 items-center'>
                    <label>{translate("Grayed out esper you don't have")}</label>
                    <input type="checkbox" checked={grayedOut} onChange={(e) => setGrayedOut(e.target.checked)} name="grayedOut" className='bg-[#212932]'/>
                </div>
            </div>
            
        </div>
        <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
            <div className='tierList flex flex-col gap-2 bg-[#171e26]' id="tierList">
                <div className='flex flex-row gap-2 items-center justify-center text-2xl'>
                    <div>{name}</div>
                    <div>{type}</div>
                </div>
                <div className='flex flex-row justify-between overflow-hidden'>
                    <div className='rounded-l border bg-gradient-to-l from-[#ff7559] basis-1/6'><img className='max-h-[80px] m-auto' src="img/rank/rankSSS.png" alt="rankSSS"/></div>
                    <Droppable isDropDisabled={isDropDisabled(1)} key={0} droppableId={"0-0"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/1.png`} alt={searchKey("UnitTag;TagName;1")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;1")}</div>
                            </div>
                            <div className={`${!isDropDisabled(1) ? 'bg-[#212932]':''} border tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[0][0].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>        
                    <Droppable isDropDisabled={isDropDisabled(4)} key={1} droppableId={"0-1"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/4.png`} alt={searchKey("UnitTag;TagName;4")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;4")}</div>
                            </div>
                            <div className={`${!isDropDisabled(4) ? 'bg-[#212932]':''} border  tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[0][1].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>        
                    <Droppable isDropDisabled={isDropDisabled(2)} key={2} droppableId={"0-2"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                        <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/2.png`} alt={searchKey("UnitTag;TagName;2")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;2")}</div>
                            </div>
                        <div className={`${!isDropDisabled(2) ? 'bg-[#212932]':''} border tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                            
                            {state[0][2].map((esper,index) => (
                            <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                            ))}
                            {provided.placeholder}
                        </div>
                        </div>
                    )}
                    </Droppable>
                    <Droppable isDropDisabled={isDropDisabled(3)} key={3} droppableId={"0-3"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/3.png`} alt={searchKey("UnitTag;TagName;3")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;3")}</div>
                            </div>
                            <div className={`${!isDropDisabled(3) ? 'bg-[#212932]':''} border rounded-r tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >                                
                                {state[0][3].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>     
                </div>
                <div className='flex flex-row justify-between'>
                <div className='rounded-l border bg-gradient-to-l from-[#ffaf22] basis-1/6'><img className='max-h-[80px] m-auto' src="img/rank/rankSS.png" alt="rankSS"/></div>
                <Droppable key={4} droppableId={"1-0"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/1.png`} alt={searchKey("UnitTag;TagName;1")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;1")}</div>
                            </div>
                            <div className={`${!isDropDisabled(1) ? 'bg-[#212932]':''} border tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[1][0].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>        
                    <Droppable key={5} droppableId={"1-1"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/4.png`} alt={searchKey("UnitTag;TagName;4")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;4")}</div>
                            </div>
                            <div className={`${!isDropDisabled(4) ? 'bg-[#212932]':''} border  tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[1][1].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>        
                    <Droppable key={6} droppableId={"1-2"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                        <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/2.png`} alt={searchKey("UnitTag;TagName;2")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;2")}</div>
                            </div>
                        <div className={`${!isDropDisabled(2) ? 'bg-[#212932]':''} border tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                            
                            {state[1][2].map((esper,index) => (
                            <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                            ))}
                            {provided.placeholder}
                        </div>
                        </div>
                    )}
                    </Droppable>
                    <Droppable key={7} droppableId={"1-3"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/3.png`} alt={searchKey("UnitTag;TagName;3")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;3")}</div>
                            </div>
                            <div className={`${!isDropDisabled(3) ? 'bg-[#212932]':''} border rounded-r tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[1][3].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable> 
                </div>
                <div className='flex flex-row justify-between'>
                    <div className='rounded-l border bg-gradient-to-l from-[#ffe794] basis-1/6'><img className='max-h-[80px] m-auto' src="img/rank/rankS.png" alt="rankS"/></div>
                    <Droppable key={8} droppableId={"2-0"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/1.png`} alt={searchKey("UnitTag;TagName;1")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;1")}</div>
                            </div>
                            <div className={`${!isDropDisabled(1) ? 'bg-[#212932]':''} border tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[2][0].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>        
                    <Droppable key={9} droppableId={"2-1"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/4.png`} alt={searchKey("UnitTag;TagName;4")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;4")}</div>
                            </div>
                            <div className={`${!isDropDisabled(4) ? 'bg-[#212932]':''} border  tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[2][1].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>        
                    <Droppable key={10} droppableId={"2-2"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                        <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/2.png`} alt={searchKey("UnitTag;TagName;2")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;2")}</div>
                            </div>
                        <div className={`${!isDropDisabled(2) ? 'bg-[#212932]':''} border tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                            
                            {state[2][2].map((esper,index) => (
                            <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                            ))}
                            {provided.placeholder}
                        </div>
                        </div>
                    )}
                    </Droppable>
                    <Droppable key={11} droppableId={"2-3"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/3.png`} alt={searchKey("UnitTag;TagName;3")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;3")}</div>
                            </div>
                            <div className={`${!isDropDisabled(3) ? 'bg-[#212932]':''} border rounded-r tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[2][3].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>
                </div>
                <div className='flex flex-row justify-between'>
                    <div className='rounded-l border bg-gradient-to-l from-[#9413ff] basis-1/6'><img className='max-h-[80px] m-auto' src="img/rank/rankA.png" alt="rankA"/></div>
                    <Droppable key={12} droppableId={"3-0"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/1.png`} alt={searchKey("UnitTag;TagName;1")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;1")}</div>
                            </div>
                            <div className={`${!isDropDisabled(1) ? 'bg-[#212932]':''} border tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[3][0].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>        
                    <Droppable key={13} droppableId={"3-1"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/4.png`} alt={searchKey("UnitTag;TagName;4")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;4")}</div>
                            </div>
                            <div className={`${!isDropDisabled(4) ? 'bg-[#212932]':''} border  tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[3][1].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>        
                    <Droppable key={14} droppableId={"3-2"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                        <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/2.png`} alt={searchKey("UnitTag;TagName;2")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;2")}</div>
                            </div>
                        <div className={`${!isDropDisabled(2) ? 'bg-[#212932]':''} border tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                            
                            {state[3][2].map((esper,index) => (
                            <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                            ))}
                            {provided.placeholder}
                        </div>
                        </div>
                    )}
                    </Droppable>
                    <Droppable key={15} droppableId={"3-3"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/3.png`} alt={searchKey("UnitTag;TagName;3")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;3")}</div>
                            </div>
                            <div className={`${!isDropDisabled(3) ? 'bg-[#212932]':''} border rounded-r tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >                                
                                {state[3][3].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>
                </div>
                <div className='flex flex-row justify-between'>
                    <div className='rounded-l border bg-gradient-to-l from-[#125bff] basis-1/6'><img className='max-h-[80px] m-auto' src="img/rank/rankB.png" alt="rankB"/></div>
                    <Droppable key={16} droppableId={"4-0"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/1.png`} alt={searchKey("UnitTag;TagName;1")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;1")}</div>
                            </div>
                            <div className={`${!isDropDisabled(1) ? 'bg-[#212932]':''} border tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[4][0].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>        
                    <Droppable key={17} droppableId={"4-1"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/4.png`} alt={searchKey("UnitTag;TagName;4")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;4")}</div>
                            </div>
                            <div className={`${!isDropDisabled(4) ? 'bg-[#212932]':''} border  tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[4][1].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>        
                    <Droppable key={18} droppableId={"4-2"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                        <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/2.png`} alt={searchKey("UnitTag;TagName;2")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;2")}</div>
                            </div>
                        <div className={`${!isDropDisabled(2) ? 'bg-[#212932]':''} border tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                            
                            {state[4][2].map((esper,index) => (
                            <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                            ))}
                            {provided.placeholder}
                        </div>
                        </div>
                    )}
                    </Droppable>
                    <Droppable key={19} droppableId={"4-3"} direction="horizontal">
                    {(provided, snapshot) => (
                        <div className='flex flex-col basis-1/4'>
                            <div className='border text-center flex flex-row justify-center gap-2 items-center'>
                                <div>
                                    <img className='w-5 ' src={`img/tags/3.png`} alt={searchKey("UnitTag;TagName;3")} /> 
                                </div>
                                <div className='hidden md:flex'>{searchKey("UnitTag;TagName;3")}</div>
                            </div>
                            <div className={`${!isDropDisabled(3) ? 'bg-[#212932]':''} border rounded-r tierListSSS grid items-start p-2 w-full h-full gap-2 grid-cols-2 md:grid-cols-4 overflow-hidden`} ref={provided.innerRef} {...provided.droppableProps} >
                                {state[4][3].map((esper,index) => (
                                <Esper grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                                ))}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                    </Droppable>
                </div>
            </div>
            <div className='filter flex flex-row'>
                <div className='flex flex-col justify-start pl-1 mt-2'>
                {typeList !== [] ?
                    typeList.map((type) => (
                        <div key={"typeList-" + type.name} id={type.id.toString()} className="flex items-center">
                            <input id={`filter-type${type.id}`} onChange={toggleType} name="type[]" checked={type.show} value={type.id.toString()} type="checkbox" className="h-4 w-4 border-gray-300 rounded text-blue-400 focus:ring-indigo-500" />
                            <label htmlFor={`filter-type${type.id}`} className="ml-3 min-w-0 justify-start">
                                <img className='pixel h-[24px] aspect-[13/14] mr-2' src={'img/tags/' + type.id.toString() + '.png'} alt={type.name} style={{ float: 'left' }} />
                                {translate(type.name.toUpperCase())}
                            </label>
                        </div>
                )) : ''}
                </div>
                <div>
                    <label>{translate('Search')}</label>
                    <div><input type="text" onChange={(e) => setSearchQ(e.target.value)} placeholder={"Name or NickName..."} className='bg-[#212932]' /></div>
                </div>
            </div>
            <Droppable isDropDisabled={false} key={20} droppableId={"20"}  direction="horizontal">
                {(provided, snapshot) => (
                <div id="esperList" className='esperList mt-2 gap-4 grid grid-cols-5 md:grid-cols-12 items-center justify-center' ref={provided.innerRef} {...provided.droppableProps}>
                    {state[5].map((esper,index) => (
                        <Esper mainList={true} grayedOut={grayedOut} esper={esper} provided={provided} key={esper.ID} index={index}/>
                    ))}
                    {provided.placeholder}
                </div>
                )}
            </Droppable>
        </DragDropContext>
        </>
        
    )
}
export default TierList;